import { AnyVariables, useQuery, UseQueryArgs, UseQueryResponse } from 'urql';

import { useDbtCloudProject } from '@/context/DbtCloudProjectProvider';

// This wrapper over useQuery indicates whether or not we are waiting for
// the project provider to mount via the fetching attribute
export const useQueryStable = <
  Data = any,
  Variables extends AnyVariables = AnyVariables,
>(
  args: UseQueryArgs<Variables, Data>,
) => {
  const [queryState, queryExecute] = useQuery(args);
  const { isInContext, isMounted } = useDbtCloudProject();
  // We check both !isMounted and isInContext because only in project-level pages
  // do we want to indicate fetching=True when an environment id is not present.
  // Account level pages are not subject to this condition.
  return [
    { ...queryState, fetching: queryState.fetching || (!isMounted && isInContext) },
    queryExecute,
  ] as UseQueryResponse<Data, Variables>;
};
